import { baseUrl, headersDefault } from "./index";

/**
 * Self-service account deletion (Apple 5.1.1(v) + Google).
 * Two-step OTP flow against the backend `DELETE /api/v1/utenti/{id}`:
 *   1) no `token` → backend emails a one-time code
 *   2) `?token=CODE` → backend anonymizes/purges the account
 */

const parseJson = async (res) => {
  try {
    return await res.json();
  } catch {
    return {};
  }
};

/** Step 1 — request the deletion code by email. */
export async function requestAccountDeletionOtp(userId) {
  const res = await fetch(`${baseUrl}/api/v1/utenti/${userId}`, {
    method: "DELETE",
    headers: headersDefault(),
  });
  const data = await parseJson(res);
  if (!res.ok) {
    throw new Error(data?.message || "Impossibile inviare il codice. Riprova.");
  }
  return data;
}

/** Step 2 — confirm deletion with the emailed code. */
export async function confirmAccountDeletion(userId, token) {
  const res = await fetch(
    `${baseUrl}/api/v1/utenti/${userId}?token=${encodeURIComponent(token)}`,
    {
      method: "DELETE",
      headers: headersDefault(),
    }
  );
  const data = await parseJson(res);
  if (!res.ok) {
    throw new Error(data?.message || "Codice non valido. Riprova.");
  }
  return data;
}
